import {useTranslation} from 'react-i18next';

import {Block} from './Block';
import deal from './deal.png'
import device from './device.png'
import pot from './pot.png'

import cls from './Advantages.module.scss'

export const Advantages = () => {

    const {t} = useTranslation();

    return (
        <div className={cls.instruction}>
            <h2>{t('Our advantages')}</h2>
            <div className={cls.blocks}>
                <Block img={device} title={t('From any device')} text={t('Quick access to a loan from any device')}/>
                <Block img={pot} title={t('We work 24/7')} text={t('We are available to you at any time of the day or night.')}/>
                <Block img={deal} title={t('Instant solution')} text={t('A quick way to solve the problem')}/>
            </div>
        </div>
    )
}